<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-md-5" style="text-align:center">
          <p class="footerText footerText1">
            Download the Doodhvale app on your phone
          </p>
          <!-- <p class="dv-content"> Available on Both Android and iOS </p> -->
          <div class="appStore">
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.technologies.subtlelabs.doodhvale"
              ><img alt="google play" src="/img/google-play.png"/></a
            ><a
              target="_blank"
              href="https://apps.apple.com/in/app/doodhvale/id1435706071"
              ><img alt="apple store" src="/img/appstore.png"
            /></a>
          </div>
          <a target="_self" href="https://www.doodhvale.com/"
            ><img
              alt="apple store"
              src="/img/doodhvale_logo.jpg"
              width="150"
              class="imgTop"
          /></a>
        </div>

        <div class="col-xs-12 col-md-4">
          <div class="bottom-social">
            <div class="bottom-social-margin">
              <div class="pd-top-10">
                <div class="dv-content">
                  <p class="contact-block__office">
                    <strong>Corporate Office: </strong>
                  </p>
                  <p class="contact-block__address">
                    B2, Vikas Chamber, D Block, Central Market, Prashant Vihar,
                    Rohini, New Delhi – 110085
                  </p>
                  <p class="contact-block__office">
                    <strong>Manufacturing & Packaging Address: </strong>
                  </p>
                  <p class="contact-block__address">
                    Khewat No.- 1165, Mini Khaata No.- 1237, Village Khewra,
                    Rai, Sonepat, Haryana - 131001
                  </p>
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <p class="contact-block__phone">
                        <a href="tel:8010342342">8010342342</a>
                      </p>
                    </div>
                    <div class="col-xs-12 col-md-6">
                      <p class="contact-block__phone">
                        <a href="mailto:care@doodhvale.com">care@doodhvale.com</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3">
          <p class="footerText usefull-links">Useful Links</p>
          <p class="usefull-links">
            <router-link to="/privacy-policy" target="_blank"
              >Privacy Policy</router-link
            >
          </p>
          <p class="usefull-links">
            <router-link to="/terms-condition" target="_blank"
              >Terms & Conditions</router-link
            >
          </p>
          <p class="usefull-links">
            <router-link to="/refund-policy" target="_blank"
              >Refund Policy</router-link
            >
          </p>
          <p class="usefull-links">
            <router-link to="/shipping-policy" target="_blank"
              >Shipping Policy</router-link
            >
          </p>
          <div class="bottom-social">
            <p class="footerText">Follow Us</p>
            <div class="bottom-social-margin">
              <div class="text-sm-center-bottom">
                <ul class="social-list text-center text-center1">
                  <li>
                    <a
                      target="_blank"
                      href="https://www.instagram.com/doodhvale/"
                    >
                    <!--sanya: replacing icons with svg images-->
                    <img src = "img/instagram-brands-solid.svg" width = "25"/>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://twitter.com/doodhvale">
                      <!--sanya: replacing icons with svg images-->
                      <img src = "img/twitter-brands-solid.svg" width = "25"/>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.facebook.com/Doodhvale/"
                    >
                    <!--sanya: replacing icons with svg images-->
                    <img src = "img/facebook-f-brands-solid.svg" height = "25"/>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.youtube.com/channel/UCvxp2fZIUMX58W7nT1T5_wg"
                    >
                    <!--sanya: replacing icons with svg images-->
                    <img src = "img/youtube-brands-solid.svg" width = "25"/>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="copyright">
        &copy; {{ year }}, by doodhvale.com | All rights reserved | Sanjeevani
        Dairy Farms Private Limited
      </div>
    </div>
  </footer>
</template>

<script>
import { Popover } from "element-ui";
export default {
  props: {
    backgroundColor: String,
    type: String,
  },
  components: {
    [Popover.name]: Popover,
  },
  mounted() {
    var condition = localStorage.getItem("isMobileVerified");
    if (condition) {
      document.getElementById("f-logout").style.display = "block";
    }
  },

  beforeDestroy() {
    // window.removeEventListener('scroll', this.onScroll)
  },
  created() {
    //alert("created")
  },
  data() {
    return {
      //bgImage: 'img/footer.png',
      year: new Date().getFullYear(),
      showNavbar: this.$route.path === "/order" ? false : true,
      lastScrollPosition: 0,
      bottomNavClicked: false,
      showBottomNavbar: true,
      scrolledToBottom: false,
    };
  },
  methods: {
    goToOffer() {
      location.href = "https://live.doodhvale.com/offers/";
    },
    goToNews() {
      window.open("https://live.doodhvale.com/news/");
    },
    goToBlog() {
      window.open("https://live.doodhvale.com/blog/");
    },
    goToProducts() {
      window.open(
        "https://live.doodhvale.com/pure-fresh-milk-online-delivery-service/"
      );
    },

    logout() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.go();
    },
    popMenu(page) {
      document.getElementsByClassName("popover")[0].style.display = "none";
      this.$router.push(page);
    },
    showBottomMenu() {
      var bottomMenu = document.getElementById("sm_bottom_menu");
      if (bottomMenu.classList.contains("hidebottomMenuBtn")) {
        this.showNavbar = true;
        document.getElementById("sm_bottom_menu").style.top = "-40px";
        this.bottomNavClicked = false;
      } else {
        if (this.bottomNavClicked == false) {
          this.showNavbar = false;
          document.getElementById("sm_bottom_menu").style.top = "-80px";
          this.bottomNavClicked = true;
          //document.getElementById('sm_bottom_menu').style.bottom = '0'
        } else {
          this.showNavbar = true;
          document.getElementById("sm_bottom_menu").style.top = "-40px";
          this.bottomNavClicked = false;
          // document.getElementById('sm_bottom_menu').style.bottom = 'auto'
        }
      }
    },
    onScroll() {
      if (!this.bottomNavClicked) {
        // Get the current scroll position
        var appDiv = document.getElementById("app");
        const currentScrollPosition = window.pageYOffset || appDiv.scrollTop;
        // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
        //alert(currentScrollPosition)

        if (currentScrollPosition < 0) {
          return;
        }
        // Here we determine whether we need to show or hide the navbar
        this.showNavbar = currentScrollPosition < this.lastScrollPosition;
        //alert(this.showNavbar)
        if (this.showNavbar) {
          document.getElementById("sm_bottom_menu").style.top = "-40px";
          //document.getElementById('sm_bottom_menu').style.bottom = 'auto'
        } else {
          document.getElementById("sm_bottom_menu").style.top = "-80px";
          // document.getElementById('sm_bottom_menu').style.bottom = '0'
        }
        // Set the current scroll position as the last scroll position
        this.lastScrollPosition = currentScrollPosition;
      }

      /*  let bottomOfWindow = Math.max(window.pageYOffset, appDiv.scrollTop, document.body.scrollTop) + window.innerHeight === appDiv.offsetHeight
       //alert(bottomOfWindow)
       if (bottomOfWindow) {
         //if(this.bottomNavClicked)
         this.showNavbar = false
         //this.bottomNavClicked = !this.bottomNavClicked
         this.showBottomNavbar = true
       }
       else{
         //this.showNavbar = false
         //this.bottomNavClicked = !this.bottomNavClicked
         this.showBottomNavbar = false
       } */
    },
  },
};
</script>
<style>
@media only screen and (min-width: 1024px) {
  .footerText {
    text-align: left;
  }
  .text-center1 {
    text-align: left !important;
  }
  .footer .copyright {
    text-align: left;
  }
  .imgTop {
    margin-top: 0.8em;
  }
}
.footer .copyright {
  text-align: center;
}
.footerText1 {
  text-align: center;
}
</style>
